import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.generated.css';
import './index.css';
import './App.css';
import App from './App';
import NewsletterKiosk from './NewsletterKiosk';
import AdminLogin from './AdminLogin';
import PrivacyPolicy from './PrivacyPolicy';
import AgeGate from './components/AgeGate';

// The server serves index.html for any non-API path, so a plain pathname check
// is enough to give these their own URLs without pulling in a router.
const route = window.location.pathname.replace(/\/+$/, '').toLowerCase();

function Root() {
  // The kiosk sits on the counter at the winery, and the admin login is not
  // public, so neither needs an age gate in front of it.
  if (route === '/newsletter') return <NewsletterKiosk />;
  if (route === '/admin') return <AdminLogin />;

  return (
    <>
      <AgeGate />
      {route === '/privacy' ? <PrivacyPolicy /> : <App />}
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
